import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

const insights = [
  {
    title: "Investment Trends 2024",
    category: "Market Analysis",
    summary: "Exploring emerging opportunities in alternative investments and technological innovation.",
  },
  {
    title: "Future of FinTech",
    category: "Industry Research",
    summary: "How AI and blockchain are reshaping financial services and wealth management.",
  },
  {
    title: "Sustainable Finance",
    category: "ESG Insights",
    summary: "The growing impact of ESG considerations in investment decisions and corporate strategy.",
  },
  {
    title: "Digital Transformation",
    category: "Technology",
    summary: "Strategic approaches to digital transformation in financial services.",
  },
]

export function LatestInsights() {
  return (
    <div className="container mx-auto px-4 py-24 bg-neutral-50 dark:bg-neutral-900">
      <div className="text-center mb-16">
        <h2 className="text-3xl font-bold tracking-tight">Latest Insights</h2>
        <p className="mt-4 text-lg text-neutral-600 dark:text-neutral-400">
          Stay informed with our latest research and analysis
        </p>
      </div>
      
      <Carousel className="w-full max-w-5xl mx-auto">
        <CarouselContent>
          {insights.map((insight, index) => (
            <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
              <Card className="h-full">
                <CardHeader>
                  <div className="text-sm text-neutral-500 dark:text-neutral-400">
                    {insight.category}
                  </div>
                  <CardTitle className="text-xl">{insight.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    {insight.summary}
                  </p>
                </CardContent>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </div>
  )
} 